const languagesLevelsOrder = [
  'Native',
  'Advanced',
  'Intermediate',
  'Pre-Intermediate',
  'Beginner'
];

export default languagesLevelsOrder;
